module.exports = __webpack_public_path__ + "img/badge-list-thumb-171.93b2bc87.png";